export default __webpack_public_path__ + "static/media/article15.0b87275c.md";